import React from "react"
import config from 'react-global-configuration';
import HeaderAll from './parts/HeaderAll'


/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class Regulation extends React.Component {

  constructor(){
    super()

    this.state = {
      item:null
    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }

  /* Handlers */


  render(){

    return(
      <div>
      <HeaderAll />
      <main>
        <div className="main-pannel">
        <section>会員規約</section>
        <section>
      <iframe

      width="100%"
      height="560"
      src={`${process.env.PUBLIC_URL}/html/regulation.html`}
      >
      </iframe>
      </section>
      </div>
      </main>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RegulationApp.js